var _style, _g, _path, _path2, _path3, _path4, _path5, _path6, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNeverSmokeIcon0001(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 219 127.6",
    style: {
      enableBackground: "new 0 0 219 127.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#6A8BE5;}\n\t.st1{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41,127.1c-0.5,0-1-0.3-1.3-0.8c-0.4-0.7-0.2-1.6,0.5-2l155.6-89.8c0.7-0.4,1.6-0.2,2,0.5 c0.4,0.7,0.2,1.6-0.5,2L41.7,126.9C41.5,127.1,41.2,127.1,41,127.1z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M175.3,95.2c0.8,0,1.5,0.7,1.5,1.5l0.2,16.9h35.9c0.5,0,0.9-0.4,0.9-0.9V95.5c0-0.5-0.4-0.9-0.9-0.9H24.6 c-0.4,0-0.9,0.3-0.9,0.9v17.2c0,0.5,0.4,0.9,0.9,0.9H174l-0.2-16.9C173.8,95.9,174.5,95.2,175.3,95.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.6,31.6c-2-3.9-4.1-7.9-2.2-14.4c1.4-4.8,4.5-8.7,8.6-11c-4.5,0.6-9.8,3-12.5,10.9c-3,8.6-0.7,13.1,1.6,17.8 c2,4,4.1,8.1,3.2,14.5c-0.8,5.7-3,10.8-5.4,14.9c4.1-4.1,8.2-9.9,9.4-16.9C29.9,39.8,27.7,35.6,25.6,31.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.9,79.4c6.5-5.3,9.9-12.5,11.7-18.3c-3.4,5.3-8.8,12.1-16.7,18.4c-7.1,5.7-5.8,13.2-3.6,18.3 C12.5,92.4,14.2,84.8,20.9,79.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.5,74.5c0.2,0,0.5-0.1,0.7-0.2c0.7-0.4,17.4-9.9,20.2-26.3c1.5-8.7-1-13.5-3.2-17.8c-2-3.8-3.5-6.8-2-12.2 c1.8-6.4,7.4-10.8,13.9-11.1c0.7,0,1.3-0.6,1.4-1.3c0.1-0.7-0.3-1.4-1-1.6C40.5,4,22.9-1.5,16.8,16.1C13.4,26,16,31.2,18.6,36.3 c1.9,3.7,3.7,7.2,2.9,12.8C19.8,61.9,9.6,71.9,9.5,72c-0.5,0.5-0.6,1.4-0.2,2C9.6,74.3,10,74.5,10.5,74.5z M24.5,49.4 c0.9-6.4-1.2-10.5-3.2-14.5c-2.4-4.7-4.6-9.1-1.6-17.8c2.7-7.9,8-10.3,12.5-10.9c-4.1,2.3-7.2,6.2-8.6,11 c-1.9,6.5,0.2,10.5,2.2,14.4c2.1,4,4.2,8.1,2.9,15.9c-1.2,7-5.4,12.7-9.4,16.9C21.5,60.3,23.7,55.2,24.5,49.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.7,81.7C22.7,81.7,22.7,81.7,22.7,81.7c13.7-11.2,14.7-29.3,14.8-30.1c0-0.7-0.5-1.4-1.2-1.5 c-0.7-0.2-1.4,0.2-1.7,0.9c-0.1,0.1-5.7,14.3-20.6,26.2c-13.7,10.9-1.3,27.6-1.2,27.8c0.3,0.4,0.7,0.6,1.2,0.6c0.2,0,0.4,0,0.6-0.1 c0.6-0.3,1-1,0.9-1.6C15.4,103.6,13,89.6,22.7,81.7z M12.2,97.8c-2.1-5-3.5-12.6,3.6-18.3c7.9-6.3,13.3-13.1,16.7-18.4 c-1.8,5.8-5.2,12.9-11.7,18.3C14.2,84.8,12.5,92.4,12.2,97.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M177,113.6l-0.2-16.9c0-0.8-0.7-1.5-1.5-1.5c-0.8,0-1.5,0.7-1.5,1.5l0.2,16.9l0,2c0,0.4,0.2,0.7,0.4,1 c0.3,0.3,0.7,0.5,1.1,0.5c0,0,0,0,0,0c0.4,0,0.8-0.2,1.1-0.5c0.2-0.3,0.4-0.6,0.4-1L177,113.6z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.6,113.6c-0.5,0-0.9-0.4-0.9-0.9V95.5c0-0.6,0.5-0.9,0.9-0.9h62l5.2-3H24.6c-2.2,0-3.9,1.7-3.9,3.9v17.2 c0,2.1,1.8,3.9,3.9,3.9h23.9l5.2-3H24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M174,113.6H70.4l-5.2,3h109.2c-0.2-0.3-0.4-0.6-0.4-1L174,113.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M212.9,91.6H108.5l-5.2,3h109.6c0.5,0,0.9,0.4,0.9,0.9v17.2c0,0.5-0.4,0.9-0.9,0.9H177l0,2 c0,0.4-0.1,0.7-0.4,1h36.3c2.1,0,3.9-1.8,3.9-3.9V95.5C216.8,93.4,215,91.6,212.9,91.6z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeverSmokeIcon0001);
export default __webpack_public_path__ + "static/media/never-smoke-icon-00-01.39cdafb8.svg";
export { ForwardRef as ReactComponent };